// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Retheme'd against Untitled UI tokens, per
   assets/handoffs/design_handoff_configuration_checklist. Band structure
   (header rule → tiles) comes from Card/Card.Header defaults; the tile grid,
   markers, badges and CTAs have no Untitled equivalent. Explicitly NOT a
   stepper — no connector line, no locking; the marker number is a label. */

.cfg-header-count {
  font-size: var(--text-sm-size);
  font-weight: 500;
  color: var(--text-secondary);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.cfg-tiles {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 16px;
  gap: 16px;
  padding: 20px 24px;
}

@media (max-width: 1199px) {
  .cfg-tiles {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {
  .cfg-tiles {
    grid-template-columns: 1fr;
  }
}

/* Tiles flip to "done" on a stagger (see WelcomeScreen.js) rather than all
   appearing done on the first frame — these transitions are what make that
   flip read as a highlight instead of a jump cut. Duration must match
   HIGHLIGHT_MS in WelcomeScreen.js. */
.cfg-tile {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-md);
  background: var(--bg-primary);
  transition: background-color 0.5s ease-out, border-color 0.5s ease-out;
}

.cfg-tile--done {
  background: var(--bg-secondary);
}

.cfg-tile--done .cfg-title {
  color: var(--text-tertiary);
}

.cfg-tile--next {
  border-color: var(--color-brand-300);
  background: var(--color-brand-25);
}

.cfg-tile-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

/* Keeps every tile's bottom slot on one line — grid stretch makes the four
   tiles equal height, and without this the done tiles have a hole where the
   button/link sits on the others. */
.cfg-tile > .cfg-cta,
.cfg-tile > .cfg-tag {
  margin-top: auto;
  padding-top: 4px;
}

.cfg-mark {
  width: 28px;
  height: 28px;
  flex: none;
  border-radius: var(--radius-full);
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  display: grid;
  place-items: center;
  font-size: var(--text-xs-size);
  font-weight: 600;
  color: var(--text-tertiary);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  transition: background-color 0.5s ease-out, border-color 0.5s ease-out,
    color 0.5s ease-out;
}

.cfg-mark--done {
  background: var(--color-success-500);
  border-color: var(--color-success-500);
  color: #ffffff;
}

.cfg-mark--next {
  background: var(--color-brand-600);
  border-color: var(--color-brand-600);
  color: #ffffff;
}

.cfg-title {
  font-size: var(--text-sm-size);
  line-height: var(--text-sm-line);
  font-weight: 600;
  color: var(--text-primary);
  transition: color 0.5s ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .cfg-tile,
  .cfg-mark,
  .cfg-title {
    transition: none;
  }
}

.cfg-explanation {
  margin: 0;
  font-size: var(--text-xs-size);
  line-height: 18px;
  color: var(--text-tertiary);
  text-wrap: pretty;
}

.cfg-tag {
  font-size: var(--text-xs-size);
  line-height: 18px;
  font-weight: 500;
  color: var(--color-success-700);
}

/* Neutral information, not a warning or status badge. */
.cfg-opt {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-full);
  background: var(--bg-tertiary);
  border: 1px solid var(--border-secondary);
  font-size: var(--text-xs-size);
  font-weight: 500;
  color: var(--text-tertiary);
}

/* Tertiary link — the "not started" bottom slot. Explicit hover colour
   (global a:hover only sets colour, not enough on its own) and explicit
   text-decoration since it's an <a> via react-router Link. */
.cfg-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--text-sm-size);
  font-weight: 600;
  color: var(--color-brand-700);
  text-decoration: none;
}

.cfg-link:hover {
  color: var(--color-brand-800);
  text-decoration: none;
}

/* Steps with no in-app action (e.g. email activation) — a status hint, not
   a dead link/button. */
.cfg-cta--muted {
  font-size: var(--text-xs-size);
  color: var(--text-tertiary);
}
`, "",{"version":3,"sources":["webpack://./src/apps/admin/pages/DashboardPage/WelcomeScreen.css"],"names":[],"mappings":"AAAA;;;;2EAI2E;;AAE3E;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,6BAAkC;EAAlC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAS;EAAT,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;sCAGsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yCAAyC;EACzC,+BAA+B;EAC/B,6BAA6B;EAC7B,sEAAsE;AACxE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;oCAEoC;AACpC;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iCAAiC;EACjC,uCAAuC;EACvC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,6BAAkC;EAAlC,kCAAkC;EAClC;uBACqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;6DAE6D;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;wBACwB;AACxB;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":["/* Retheme'd against Untitled UI tokens, per\n   assets/handoffs/design_handoff_configuration_checklist. Band structure\n   (header rule → tiles) comes from Card/Card.Header defaults; the tile grid,\n   markers, badges and CTAs have no Untitled equivalent. Explicitly NOT a\n   stepper — no connector line, no locking; the marker number is a label. */\n\n.cfg-header-count {\n  font-size: var(--text-sm-size);\n  font-weight: 500;\n  color: var(--text-secondary);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.cfg-tiles {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  padding: 20px 24px;\n}\n\n@media (max-width: 1199px) {\n  .cfg-tiles {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 767px) {\n  .cfg-tiles {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Tiles flip to \"done\" on a stagger (see WelcomeScreen.js) rather than all\n   appearing done on the first frame — these transitions are what make that\n   flip read as a highlight instead of a jump cut. Duration must match\n   HIGHLIGHT_MS in WelcomeScreen.js. */\n.cfg-tile {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-md);\n  background: var(--bg-primary);\n  transition: background-color 0.5s ease-out, border-color 0.5s ease-out;\n}\n\n.cfg-tile--done {\n  background: var(--bg-secondary);\n}\n\n.cfg-tile--done .cfg-title {\n  color: var(--text-tertiary);\n}\n\n.cfg-tile--next {\n  border-color: var(--color-brand-300);\n  background: var(--color-brand-25);\n}\n\n.cfg-tile-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n/* Keeps every tile's bottom slot on one line — grid stretch makes the four\n   tiles equal height, and without this the done tiles have a hole where the\n   button/link sits on the others. */\n.cfg-tile > .cfg-cta,\n.cfg-tile > .cfg-tag {\n  margin-top: auto;\n  padding-top: 4px;\n}\n\n.cfg-mark {\n  width: 28px;\n  height: 28px;\n  flex: none;\n  border-radius: var(--radius-full);\n  border: 1px solid var(--border-primary);\n  background: var(--bg-primary);\n  display: grid;\n  place-items: center;\n  font-size: var(--text-xs-size);\n  font-weight: 600;\n  color: var(--text-tertiary);\n  font-variant-numeric: tabular-nums;\n  transition: background-color 0.5s ease-out, border-color 0.5s ease-out,\n    color 0.5s ease-out;\n}\n\n.cfg-mark--done {\n  background: var(--color-success-500);\n  border-color: var(--color-success-500);\n  color: #ffffff;\n}\n\n.cfg-mark--next {\n  background: var(--color-brand-600);\n  border-color: var(--color-brand-600);\n  color: #ffffff;\n}\n\n.cfg-title {\n  font-size: var(--text-sm-size);\n  line-height: var(--text-sm-line);\n  font-weight: 600;\n  color: var(--text-primary);\n  transition: color 0.5s ease-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cfg-tile,\n  .cfg-mark,\n  .cfg-title {\n    transition: none;\n  }\n}\n\n.cfg-explanation {\n  margin: 0;\n  font-size: var(--text-xs-size);\n  line-height: 18px;\n  color: var(--text-tertiary);\n  text-wrap: pretty;\n}\n\n.cfg-tag {\n  font-size: var(--text-xs-size);\n  line-height: 18px;\n  font-weight: 500;\n  color: var(--color-success-700);\n}\n\n/* Neutral information, not a warning or status badge. */\n.cfg-opt {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: var(--radius-full);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-secondary);\n  font-size: var(--text-xs-size);\n  font-weight: 500;\n  color: var(--text-tertiary);\n}\n\n/* Tertiary link — the \"not started\" bottom slot. Explicit hover colour\n   (global a:hover only sets colour, not enough on its own) and explicit\n   text-decoration since it's an <a> via react-router Link. */\n.cfg-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--text-sm-size);\n  font-weight: 600;\n  color: var(--color-brand-700);\n  text-decoration: none;\n}\n\n.cfg-link:hover {\n  color: var(--color-brand-800);\n  text-decoration: none;\n}\n\n/* Steps with no in-app action (e.g. email activation) — a status hint, not\n   a dead link/button. */\n.cfg-cta--muted {\n  font-size: var(--text-xs-size);\n  color: var(--text-tertiary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
